import React, { useEffect } from "react";
import { useGeneralSheetHook } from "../../hooks/sheet.hook";

const AboutComponent = () => {

  const sheet_data = useGeneralSheetHook()

  useEffect(() => {
    const $ = window.$; // Ensure jQuery is available
    if ($(".video-popup").length) {
      $(".video-popup").magnificPopup({
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 160,
        preloader: true,
        fixedContentPos: false,
      });
    }
  }, []); // Empty dependency array to mimic componentDidMount

  const publicUrl = process.env.PUBLIC_URL + "/";

  return (
    <section className="about-one about-three">
      <div className="container">
        <div className="row">
          <div className="col-xl-6">
            <div
              className="about-one__left wow slideInLeft"
              data-wow-delay="100ms"
              data-wow-duration="2500ms"
            >
              <div className="about-one__img-box">
                <div className="about-one__img">
                  <img
                    src={
                      publicUrl + "assets/images/resources/about-one-img-1.jpg"
                    }
                    alt=""
                  />
                </div>
                <div
                  className="about-one__small-img wow zoomIn animated animated"
                  data-wow-delay="500ms"
                  data-wow-duration="2500ms"
                >
                  <img
                    src={
                      publicUrl +
                      "assets/images/resources/about_one_small_img-1.jpg"
                    }
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="about-one__right">
              <div className="about-one__right-content">
                <div className="section-title text-left">
                  <span className="section-title__tagline">About Us</span>
                  <h2 className="section-title__title">
                    We transform experiences and elevate brands.
                  </h2>
                </div>
                <p className="about-one__text">
                  Concept Multi-Services NIG is a dynamic, full-service
                  consultancy dedicated to delivering innovative solutions
                  across multiple industries. Our expertise spans:
                </p>
                <ul className="list-unstyled about-one__points">
                  <li>
                    <div className="icon">
                      <span className="icon-comment"></span>
                    </div>
                    <div className="text">
                      <h4>Entertainment and Culture.</h4>
                      <p>
                        Getting brands involved in societal development through
                        an entertaining platform.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="icon-comment"></span>
                    </div>
                    <div className="text">
                      <h4>Branding and Advertising</h4>
                      <p>
                        Strategic brand development, advertising avenues, and
                        word of mouth marketing.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="icon-comment"></span>
                    </div>
                    <div className="text">
                      <h4>Automobile Purchase/Sales</h4>
                      <p>
                        Vehicle acquisition, sales, and after-sales support.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="icon-comment"></span>
                    </div>
                    <div className="text">
                      <h4>Tourist Services</h4>
                      <p>
                        Personalized travel experiences, destination management,
                        and cultural immersion programs.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="icon-comment"></span>
                    </div>
                    <div className="text">
                      <h4>Diaspora Bridge Services</h4>
                      <p>
                        A trusted personal assistant on the ground in Nigeria
                        for Nigerians abroad, handling errands, property
                        checks, family visits and follow-ups on your behalf.
                      </p>
                    </div>
                  </li>
                </ul>
                <div className="about-one__bottom-video-box">
                  <div className="about-one__btn-box">
                    <a href="/contact" className="thm-btn about-one__btn">
                      Contact Us
                    </a>
                  </div>
                  <div className={`about-one__video-link ${sheet_data.about_video ? "" : "d-none"}`}>
                    <a
                      href={sheet_data.about_video}
                      className="video-popup"
                    >
                      <div className="about-one__video-icon">
                        <span className="fa fa-play"></span>
                        <i className="ripple"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutComponent;
